import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';
import Breadcrumbs from '../../../common/components/Breadcrumbs';
import { Breadcrumb } from '../../../common/types/api/v4/boats/search';
import BookingCounter from '../BookingCounter';
import BookingReview from '../BookingReview';

import styles from './BookingOverview.module.scss';

export type BookingOverviewProps = {
  averageRating: number;
  totalReviews: number;
  totalBookings: number;
  breadcrumbs: Breadcrumb[] | null;
  category: Breadcrumb;
  showBottomBorder?: boolean;
};

const BookingOverview: FC<BookingOverviewProps> = ({
  averageRating,
  totalReviews,
  totalBookings,
  breadcrumbs,
  category,
  showBottomBorder = true,
}) => {
  const { previewMode } = usePreviewModeContext();
  const hasReviews = totalReviews > 0;
  const hasBookingCount = totalBookings > 0;
  const hasBreadcrumbs = (breadcrumbs?.length ?? 0) > 0;

  if (!previewMode && !hasReviews && !hasBookingCount && !hasBreadcrumbs) {
    return null;
  }

  return (
    <div className={getClassNames(styles, 'root', classNames({ showBottomBorder }))}>
      <BookingReview
        condensed
        averageRating={averageRating}
        totalReviews={totalReviews}
        disabled={previewMode}
      />
      {(previewMode || (hasReviews && (hasBookingCount || hasBreadcrumbs))) && (
        <span className={getClassNames(styles, 'divider', classNames({ disabled: previewMode }))}> · </span>
      )}
      <BookingCounter
        classNameModifier={classNames('listingPage', { disabled: previewMode })}
        totalBookings={totalBookings}
        disabled={previewMode}
      />
      {(previewMode || (hasBookingCount && hasBreadcrumbs))
        && <span className={getClassNames(styles, 'divider', classNames({ disabled: previewMode }))}> · </span>}
      <Breadcrumbs
        commaSeparated
        classNameModifier="listingPage"
        breadcrumbs={breadcrumbs}
        category={category}
        previewMode={previewMode}
      />
    </div>
  );
};

export default BookingOverview;
